export default {
  options(h, conf, key) {
    const list = []
    if (conf.bpmConfig.optionType === 1 && conf.bpmConfig.statisticsTmpId === '1742922669609455618') {
      if (conf.axiosOptions) {
        const axiosOptions = conf.axiosOptions
        axiosOptions.forEach(item => {
          list.push(
            <el-option value={item.projectId} class='axiosOptions'>
              <p>
                <span>项目简称：</span>
                <span>{ item.projectAbbreviate ? '【' + item.projectAbbreviate + '】' : '--' }</span>
              </p>
              <p>
                <span>项目编号：</span>
                <span>{ item.projectId || '--' }</span>
              </p>
              <p>
                <span>创建人：</span>
                <span>{ item.createBy || '--' }</span>
              </p>

              {
                item.projectType === 1 &&
                <p>
                  <span>客户编号：</span>
                  <span>{ item.customerId || '--' }</span>
                </p>
              }
              {
                item.projectType === 1 &&
                <p>
                  <span>客户名称：</span>
                  <span>{ item.customer || '--' }</span>
                </p>
              }

              {
                item.projectType === 2 &&
                <p>
                  <span>商机名称：</span>
                  <span>{ item.business || '--' }</span>
                </p>
              }
              {
                item.projectType === 2 &&
                <p>
                  <span>客户名称：</span>
                  <span>{ item.customer || '--' }</span>
                </p>
              }

              {
                item.projectType === 3 &&
                <p>
                  <span>项目管理员：</span>
                  <span>{ item.projectHead && item.projectHead.length > 0 ? item.projectHead[0].name : '--' }</span>
                </p>
              }
              {
                item.projectType === 3 &&
                <p>
                  <span>产品线：</span>
                  <span>{ item.productLine || '--' }</span>
                </p>
              }

              {
                item.projectType === 4 &&
                <p>
                  <span>项目管理员：</span>
                  <span>{ item.projectHead && item.projectHead.length > 0 ? item.projectHead[0].name : '--' }</span>
                </p>
              }
              {
                item.projectType === 4 &&
                <p>
                  <span>预算部门：</span>
                  <span>{ item.budgetDepartment || '--' }</span>
                </p>
              }

            </el-option>
          )
        })
      }
    } else {
      conf.bpmSlot.options.forEach(item => {
        list.push(<el-option label={item.label} value={item.value} disabled={item.disabled}></el-option>)
      })
    }

    return list
  }
}
